import { useMutation, useQueryClient } from 'react-query';
import { shutdownAlisaActiveQuery } from '../../../../shared/api/queries';
import request from '../../../../../../helpers/request';
import { useShutdownAlisaIvrCompanyStateChange } from '../../changeAlisaIvrCompanyState';

const { shutdownAlisaActiveKey } = shutdownAlisaActiveQuery;

const changeAlisaState = async ({ shutdownId, data }) => {
  const res = await request.put(
    `/Alert/alisa_active/${shutdownId}`,
    data,
    `Не удалось ${data === true ? 'включить' : 'отключить'} автоответчик`,
    'Error'
  );

  return res;
};

export const useShutdownAlisaStateChange = (options = {}) => {
  const queryClient = useQueryClient();

  const { change: changeIvr } = useShutdownAlisaIvrCompanyStateChange();

  const changeMutation = useMutation(changeAlisaState, {
    ...options,
    onSuccess: async (res, { shutdownId, data }) => {
      if (res !== 'Error') {
        queryClient.setQueryData(
          shutdownAlisaActiveKey(shutdownId),
          () => data
        );

        if (data === false) {
          await changeIvr({ shutdownId, data: 0 });
        }
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
